
import { QuestionCircleTwoTone } from '@ant-design/icons'
import { ColDef } from 'ag-grid-community'
import { Popover, TableColumnType } from 'antd'
import moment from 'moment'
import React, { useRef } from 'react'
import { AnyIfEmpty } from 'react-redux'
import { getSexData } from '../../../models/ToothHome'
import { getAge } from '../../../utils/StringUtils'
import { DateTimeFormatSimples } from '../../../models/datetime'
import { getMaskPhone } from '../../../models/phone'

export const DoctorAchievementColumns = (
  categoryValue?: number,
  data?: any,
  CKLRSJData?: boolean
): TableColumnType<any>[] => {

  const Tips = (title: string) => {
    let tip = ''
    if (title == '处方数') {
      tip = '注：补交数据不纳入统计'
    } else if (title == '人次') {
      tip = '注：补交数据不纳入统计'
    } else if (title == '人均') {
      tip = '注：补交数据不纳入统计，按总费用进行统计'
    } else if (title == '总费用') {
      tip = '注：补交数据不纳入统计'
    } else if (title == '应收总金额') {
      tip = '注：补交数据不纳入统计'
    } else if (title == '实收金额') {
      tip = '注：实收的自费金额，补交数据统计规则可点击右上角的设置进行调整'
    } else if (title == '成本总金额') {
      tip = '注：补交数据不纳入统计'
    } else if (title == '处方总费用') {
      tip = '注：按处方分类查询时，处方总金额不统计抹零或手动修改的优惠金额'
    }
    return <>
      {title}
      <Popover
        placement='top'
        content={tip}
      >
        <QuestionCircleTwoTone style={{ marginLeft: '5px' }} />
      </Popover>
    </>
  }

  const colsTop: TableColumnType<any>[] = [
    categoryValue == 1 ? {
      title: "医生姓名",
      key: 'treatmentDoctorName',
      width: '4.5rem',
      align: 'center',
      render: (_, e, i) => {
        let span = 0
        if (
          i === 0 ||
          data && data[i - 1]?.treatmentDoctorId !==
          e.treatmentDoctorId
        ) {
          for (let j = i; j < data?.length; ++j) {
            if (
              data[j].treatmentDoctorId ===
              e.treatmentDoctorId
            ) {
              ++span
            } else {
              break
            }
          }
        }
        return {
          props: {
            colSpan: 1,
            rowSpan: span,
            style: {
              whiteSpace: 'nowrap',
            },
          },
          children: e.treatmentDoctorName || '',
        }
      }
    } : {
      title: "医生姓名",
      key: "treatmentDoctorName",
      align: "center",
      render: (_, e) => {
        return {
          props: {
            style: {
              whiteSpace: "nowrap",
            },
          },
          children: e.treatmentDoctorName,
        }
      },
    },
    {
      title: "处方类型",
      key: "categoryName",
      dataIndex: "categoryName",
      align: "center",
      render: (_, r: any) => {
        return r?.categoryName == '合计' ? '' : r?.categoryName
      },
    },
    {
      title: Tips('处方数'),
      dataIndex: "recipeCount",
      align: "center",
    },
    {
      title: Tips('人次'),
      key: "personTime",
      dataIndex: "personTime",
      align: "center",
      render: (_, r) => {
        return categoryValue == 1 ? '-' : r.personTime
      },
    },
    {
      title: Tips('人均'),
      key: "personTimeAvgAmount",
      dataIndex: "personTimeAvgAmount",
      align: "center",
      render: (_, r) => {
        return categoryValue == 1 ? '-' : r.personTimeAvgAmount?.toFixed(2)
      },
    },
    {
      title: categoryValue == 1 ? Tips('处方总费用') : Tips('总费用'),
      dataIndex: "totalPayAmount",
      align: "center",
      render: (_, r) => r.totalPayAmount?.toFixed(2),
    },
    {
      title: Tips('应收总金额'),
      dataIndex: "shoudPayAmount",
      key: "shoudPayAmount",
      align: "center",
      render: (_, r) => r.shoudPayAmount?.toFixed(2),
    },
    {
      title: Tips('实收金额'),
      dataIndex: "realPayAmount",
      align: "center",
      render: (_, r) => {
        return categoryValue == 1 ? '-' : r.realPayAmount?.toFixed(2)
      },
    },
    {
      title: "医保报销金额",
      dataIndex: "totalInsurancePayAmount",
      align: "center",
      render: (_, r) => {
        return categoryValue == 1 ? '-' : r.totalInsurancePayAmount?.toFixed(2)
      },
    },
    {
      title: Tips('成本总金额'),
      key: "totalCost",
      align: "center",
      render: (_, r) => !CKLRSJData ? '***' : r.totalCost?.toFixed(2),
    },
    {
      title: "利润",
      key: "profit",
      align: "center",
      render: (_, r) => !CKLRSJData ? '***' : r.profit?.toFixed(2),
    },
    {
      title: "利润率",
      key: "profitRate",
      align: "center",
      render: (_, r) => !CKLRSJData ? '***' : r.profitRate,
    },
  ]
  return categoryValue == 1 ? colsTop?.filter((item) => item.key !== 'shoudPayAmount') : colsTop.filter((item) => item.key !== 'categoryName')
}

export const AGColumns = (
  startIndex: number,
  columnList?: any,
  CKHZSJHData?: boolean
): ColDef[] => {
  return (
    columnList?.map((item: any) => {
      // 根据注释掉的列配置，补充 cellRendererFramework 或 valueFormatter
      switch (item.field) {
        case 'index':
          return {
            ...item,
            cellStyle: { textAlign: 'center', },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) {
                return '合计'
              }
              return `${Number(startIndex || 0) + params.node.rowIndex + 1}`
            },
          };
        case 'departmentName': //科室
        case 'doctorName': //医生姓名
        case 'patientName': //患者姓名
        case 'medicalNumber': //病历号
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const field = item.field;
              const val = t?.[field]
              return val == '-1' || !val ? '-' : val
            },
          };
        case 'phone': //手机号
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const field = item.field;
              const val = t?.[field]
              return val ? (!CKHZSJHData ? getMaskPhone(val) : val) : '-'
            },
          };
        case 'settlementTime': // 收费时间
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const field = item.field;
              const val = t?.[field]
              return val ? moment(val).format(DateTimeFormatSimples) : '-'
            },
          };
        case 'feeType': //收费类型
          // 0 收费 1补交 2 退费
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              const t = params.data;
              if (params.node.rowPinned) return '';
              return t?.feeType == 0 ? '收费' : t?.feeType == 1 ? '补交' : t?.feeType == 2 ? '退费' : '-'
            },
          };
        case 'gender': //性别
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              const t = params.data;
              if (params.node.rowPinned) return '';
              return getSexData(Number(t.gender))
            },
          };
        case 'age': //年龄
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              const t = params.data;
              if (params.node.rowPinned) return '';
              return getAge(t?.age, t?.ageMonth, '岁', t?.ageDay)
            },
          };
        case 'furtherConsideration': //接诊类型
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              const t = params.data;
              if (params.node.rowPinned) return '';
              return t?.furtherConsideration == 0 ? '初诊' : t?.furtherConsideration == 1 ? '复诊' : '-'
            },
          };
        case 'totalPayAmount': // 总金额
        case 'shouldPayAmount': //应收金额
        case 'realPayAmount': //本次实收
        case 'commissionAmount': //计提金额
        case 'billingCategory01': //西药费
        case 'billingCategory02': //中成药
        case 'billingCategory03': //中草药
        case 'billingCategory30': //挂号费
        case 'billingCategory04': //诊查费
        case 'billingCategory97': //代煎费
        case 'billingCategory06': //检查费
        case 'billingCategory05': //治疗费
        case 'billingCategory07': //化验费
        case 'billingCategory08': //手术费
        case 'billingCategory09': //放射费
        case 'billingCategory10': //输血费
        case 'billingCategory11': //输氧费
        case 'billingCategory34': //护理费
        case 'billingCategory23': //B超费
        case 'billingCategory24': //心电图费
        case 'billingCategory26': //透析费
        case 'billingCategory27': //化疗费
        case 'billingCategory28': //麻醉费
        case 'billingCategory25': //注射费
        case 'billingCategory99': //其他费
        case 'otherMedicines': //其他药品
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              const t = params.data;
              const field = item.field;
              const val = t?.[field]
              return val?.toFixed(2) || '0.00'
            },
          };
        default:
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
          };
      }
    })
  )
}